import { render, staticRenderFns } from "./4.vue?vue&type=template&id=1f1b2687&scoped=true"
import script from "./4.vue?vue&type=script&lang=js"
export * from "./4.vue?vue&type=script&lang=js"
import style0 from "./4.vue?vue&type=style&index=0&id=1f1b2687&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1b2687",
  null
  
)

export default component.exports